import { createReducer } from "@reduxjs/toolkit";
import { resetUpdateUser, updateUser } from "./update-user";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const updateUserReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(updateUser.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(updateUser.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateUser.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateUser, () => {
    return initialState;
  });
});
